import { useContext } from "react";
//context
import { ActivityFeedContext } from "@/context/ActivityFeedContext";

const UseDownloadReportButton = () => {
    const {downloadCSV, activities, setIsDownloadingCSV, isDownloadingCSV} = useContext(ActivityFeedContext);
    
    const buttonText : string = isDownloadingCSV ? "Downloading" : "Download";
    const buttonAriaLabel : string = "Download CSV file";
    const tooltipText : string = activities.length < 1 ? "No activities available for download" : "Download up to 2000 records of your current activity selection";
    const isDisabled : boolean = activities.length < 1 || isDownloadingCSV;
    const buttonClassName : string = activities.length < 1 ? "no-activities-tooltip" : "download-button-tooltip";
    
    function onButtonClick() {
        setIsDownloadingCSV(true);
        downloadCSV();
    }

    return {
        buttonText, buttonAriaLabel, tooltipText, isDisabled, buttonClassName, onButtonClick, isDownloadingCSV
    }
}
export default UseDownloadReportButton